import axiosInstance from "../axios-interceptor";
import { AppSettings } from "../constant";

const { Ewaste } = AppSettings;

export const getNotifications = async (userLoginId) => {
  const res = await axiosInstance.get(
    `${Ewaste.getNotifications}?userLoginId=${userLoginId}`
  );
  return res?.data?.response;
};

export const getNotificationCount = async (userLoginId) => {
  const res = await axiosInstance.get(
    `${Ewaste.getNotificationCount}?userLoginId=${userLoginId}`
  );
  return res?.data?.response;
};

export const markNotificationRead = async (notificationId, userLoginId) => {
  const res = await axiosInstance.post(Ewaste.markNotificationRead, {
    notificationId,
    userLoginId,
  });
  return res?.data;
};

export const reviewEwasteRequest = async (requestId, status, rejectionReason) => {
  const res = await axiosInstance.post(Ewaste.reviewEwasteRequest, {
    requestId,
    status,
    rejectionReason,
  });
  return res?.data;
};